export default __webpack_public_path__ + "static/media/arrow_toggle_right.bbc16b32.svg";